
import { useStudents } from "@/contexts";
import { StudentFormData } from "./types";

export const useDefaultValues = () => {
  const { programCategories, programsByCategory } = useStudents();

  const defaultValues: StudentFormData = {
    name: "",
    surname: "",
    fathersName: "",
    age: undefined,
    address: "",
    province: "",
    country: "",
    contactNumber: "",
    email: "",
    profileImage: "",
    qualificationLevel: undefined,
    documents: [],
    programs: [{
      category: programCategories[0],
      title: programsByCategory[programCategories[0]][0],
      fee: 0,
      enrolledAt: new Date(),
      duration: 30,
      feeStatus: 'paid',
      nextPaymentDate: undefined,
    }],
    // New institution default values
    institutionAddress: "",
    institutionPhone: "",
    institutionEmail: "",
    authorizedBy: "",
    policyNote: "Without stamp the slip is invalid.",
  };

  return {
    defaultValues,
    programCategories,
    programsByCategory
  };
};
